module.exports = __webpack_public_path__ + "img/ico-burger.27081d9c.svg";